export default "__VITE_ASSET__CzLSmkHc__"